import CheckoutComponent from '@views/checkout/ase';

export default [
  {
    path: '/checkout',
    name: 'checkout',
    component: CheckoutComponent,
    meta: {
      resourceOptional: true,
      sidebar: 'hide',
    },
  },
];
